<script>
export default {
    name: "ConfirmApproval",

    props: {

        journalDetails: Object,
        showModal: Boolean
    },

    methods: {

        confirmApproval() {
            this.$root.loading = true;
            this.$accountsHttp.post(`InventoryJournal/ApproveInventoryJournal`, this.journalDetails).then(response => {
                this.$root.loading = false;
                this.$emit('closeModal');
                window.Swal.fire({ text: response.data, type: 'success', showCancelButton: false });
            }).catch(() => { this.$root.loading = false; this.$emit('closeModal'); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 w-2/3">
      <template v-slot:modal-body>
        <h5 class="text-center font-semibold text-sm">Confirm approval of the journals.</h5>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-4" @click.prevent="$emit(`closeModal`)">
          <i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs" @click.prevent="confirmApproval">
            <i class="fa fa-check"></i> Approve</button>
      </template>
    </tail-modal>
</template>
